module.exports = "/_next/static/images/toy-train-9c16c9dea480ac338158b498dcd42ce2.svg";